// extracted by mini-css-extract-plugin
module.exports = {"brandBlocks":"GridBox-module--brandBlocks--3l7PL","dashed":"GridBox-module--dashed--1Ys6y"};